'use strict';

var Curry = require("bs-platform/lib/js/curry.js");

function RingExtensions(R) {
  var $neg = R.subtract;
  var negate = function (v) {
    return Curry._2($neg, R.zero, v);
  };
  return {
          $neg: $neg,
          negate: negate
        };
}

exports.RingExtensions = RingExtensions;
/* No side effect */
